/* ---------------------------------------------------------------------------
   Revealed image on scroll
   A tall stage with a sticky viewport-height frame inside it. As the stage
   passes the viewport we write a single 0..1 progress value to a CSS custom
   property; the stylesheet does the rest, so there is no per-frame layout
   work in JS beyond one rect read.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = [];
  var ticking = false;

  function Reveal(stage) {
    this.stage = stage;
    this.root = stage.closest('.m-revealed') || stage;
    /* starts true so the effect still runs if IntersectionObserver is
       unavailable or slow to deliver its first entry; the observer only
       switches it off once the stage is safely out of view */
    this.visible = true;
    this.last = -1;
    this.watch();
  }

  Reveal.prototype.progress = function () {
    var r = this.stage.getBoundingClientRect();
    var travel = r.height - window.innerHeight;
    if (travel <= 0) return r.top <= 0 ? 1 : 0;
    var p = -r.top / travel;
    return p < 0 ? 0 : p > 1 ? 1 : p;
  };

  Reveal.prototype.update = function () {
    if (!this.visible) return;
    var p = reduced ? 1 : this.progress();
    /* two decimals is finer than a pixel at these sizes and avoids
       re-styling on every hairline scroll */
    p = Math.round(p * 100) / 100;
    if (p === this.last) return;
    this.last = p;
    this.root.style.setProperty('--rv-p', String(p));
  };

  Reveal.prototype.watch = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) { this.visible = true; this.update(); return; }
    var io = new IntersectionObserver(function (entries) {
      self.visible = entries[0].isIntersecting;
      if (self.visible) self.update();
    }, { rootMargin: '100px 0px' });
    io.observe(this.stage);
  };

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      for (var i = 0; i < items.length; i++) items[i].update();
      ticking = false;
    });
  }

  function init(scope) {
    var root = scope || document;
    [].slice.call(root.querySelectorAll('[data-revealed-stage]')).forEach(function (stage) {
      if (stage.hpRevealed) return;
      stage.hpRevealed = true;
      var r = new Reveal(stage);
      items.push(r);
      r.update();
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
